export default __webpack_public_path__ + "img/cube-outline.a9fbf62b.svg";